import { Client } from 'app/shared/models/client.model';
import { Organisation } from 'app/shared/models/organisation.model';
import { ExecutiveSummary } from 'app/shared/models/executive-summary.model';

/**
 * Model for the Onboarding response.

 */
export class OnBoardResponseModel {
    client: Client;
    executiveSummary: ExecutiveSummary;
    orgVO: Organisation;
}



// WEBPACK FOOTER //
// ./src/app/clients/client/header/onboard-response.model.ts